// src/constants/payments.js
import { LABELS, BRAND_COLOR, PM_GROUPS } from '../paymentDefs';

// --- カードの「タッチあり/なし」ペア定義 -----------------
export const CARD_TAP_PAIRS = {
  visa:       { tap: 'visa_touch',       noTap: 'visa_no_touch' },
  mastercard: { tap: 'mastercard_touch', noTap: 'mastercard_no_touch' },
  jcb:        { tap: 'jcb_touch',        noTap: 'jcb_no_touch' },
  amex:       { tap: 'amex_touch',       noTap: 'amex_no_touch' },
  diners:     { tap: 'diners_touch',     noTap: 'diners_no_touch' },
  discover:   { tap: 'discover_touch',   noTap: 'discover_no_touch' },
  unionpay:   { tap: 'unionpay_touch',   noTap: 'unionpay_no_touch' },
};

// --- カードIDを「タッチあり/なし」に展開 -------------------
export const CARD_IDS_EXPANDED = (PM_GROUPS.card || []).flatMap((id) => {
  const pair = CARD_TAP_PAIRS[id];
  return pair ? [pair.tap, pair.noTap] : [id];
});

// --- ラベル（既存 + 追加） ---------------------------------
export const PAYMENT_LABELS = {
  ...LABELS,
  visa_touch: 'Visa（タッチ決済あり）',
  visa_no_touch: 'Visa（タッチ決済なし）',
  mastercard_touch: 'Mastercard（タッチ決済あり）',
  mastercard_no_touch: 'Mastercard（タッチ決済なし）',
  jcb_touch: 'JCB（タッチ決済あり）',
  jcb_no_touch: 'JCB（タッチ決済なし）',
  amex_touch: 'American Express（タッチ決済あり）',
  amex_no_touch: 'American Express（タッチ決済なし）',
  diners_touch: 'Diners Club（タッチ決済あり）',
  diners_no_touch: 'Diners Club（タッチ決済なし）',
  discover_touch: 'Discover（タッチ決済あり）',
  discover_no_touch: 'Discover（タッチ決済なし）',
  unionpay_touch: '銀聯（タッチ決済あり）',
  unionpay_no_touch: '銀聯（タッチ決済なし）',
};

// --- カラー（既存 + 追加） ---------------------------------
export const PAYMENT_COLORS = {
  ...BRAND_COLOR,
  visa_touch: BRAND_COLOR.visa ?? '#1a1f71',
  visa_no_touch: BRAND_COLOR.visa ?? '#1a1f71',
  mastercard_touch: BRAND_COLOR.mastercard ?? '#eb001b',
  mastercard_no_touch: BRAND_COLOR.mastercard ?? '#eb001b',
  jcb_touch: BRAND_COLOR.jcb ?? '#0060a9',
  jcb_no_touch: BRAND_COLOR.jcb ?? '#0060a9',
  amex_touch: BRAND_COLOR.amex ?? '#2e77bb',
  amex_no_touch: BRAND_COLOR.amex ?? '#2e77bb',
  diners_touch: BRAND_COLOR.diners ?? '#0079be',
  diners_no_touch: BRAND_COLOR.diners ?? '#0079be',
  discover_touch: BRAND_COLOR.discover ?? '#ff6000',
  discover_no_touch: BRAND_COLOR.discover ?? '#ff6000',
  unionpay_touch: BRAND_COLOR.unionpay ?? '#2e8b57',
  unionpay_no_touch: BRAND_COLOR.unionpay ?? '#2e8b57',
};

// --- セクション（カードは展開版を使用） ---------------------
export const PAYMENT_SECTIONS = [
  (PM_GROUPS.qr || []).length
    ? { key: 'qr', title: 'QR/コード決済', ids: PM_GROUPS.qr }
    : null,
  (PM_GROUPS.emoney || []).length
    ? { key: 'emoney', title: '電子マネー', ids: PM_GROUPS.emoney }
    : null,
  { key: 'card', title: 'クレジット/デビット', ids: CARD_IDS_EXPANDED },
  (PM_GROUPS.wallet || []).length
    ? { key: 'wallet', title: 'ウォレット/アプリ', ids: PM_GROUPS.wallet }
    : null,
  (PM_GROUPS.local || []).length
    ? { key: 'local', title: '地域通貨', ids: PM_GROUPS.local }
    : null,
].filter(Boolean);

// --- すべてのID一覧（重複除去） ----------------------------
export const ALL_PAYMENT_IDS = Array.from(
  new Set([
    ...(PM_GROUPS.qr || []),
    ...(PM_GROUPS.emoney || []),
    ...CARD_IDS_EXPANDED,
    ...(PM_GROUPS.wallet || []),
    ...(PM_GROUPS.local || []),
  ])
);
